import React, { FC } from 'react'

const SoundPackLicenseCommercial: FC<{ headerHeight: string }> = ({ headerHeight }) => {
  React.useEffect(() => {
    document.title = 'Artist Sound Pack - Commercial License'
  }, [])

  return (
    <iframe
      style={{ height: 'calc(100vh - ' + headerHeight + ')' }}
      src="/static/pdf/Arpeggi - Artist Sound Pack - Commercial License.pdf"
    />
  )
}

export default SoundPackLicenseCommercial
